import React from 'react';
import * as ReactGA from 'react-ga';
import { useDispatch, useSelector } from 'react-redux';
import c from 'classnames';
import styles from './Menu.css';
import {
  documentSetCookie,
} from '../../cookie';
import { useHistory } from 'react-router-dom';
import { Search } from '../search';
import { SocialBar } from '../socialbar';
import { SlideIn, SlideInHeader } from '../slidein';
import {
  selectMenuActive,
  changeMenuAction, selectSettingsMenuState, changeSubSettingsMenuAction, selectUploadFormActive,
  changeSubUploadMenuAction, selectHistoryMenuActive, changeHistoryMenuAction, selectContactFormActive,
  changeContactFormAction,
} from '../../ducks';
import { useDidomiReady } from '../commons';
import { MENU } from '../../lib/labels';
import { MenuItem } from './';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Menu = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuActive = useSelector(selectMenuActive);
  const subSettingsActive = useSelector(selectSettingsMenuState);
  const subUploadFormActive = useSelector(selectUploadFormActive);
  const subHistoryActive = useSelector(selectHistoryMenuActive);
  const subContactFormActive = useSelector(selectContactFormActive);
  const didomiReady = useDidomiReady();

  return(
    <SlideIn
      isActive={menuActive}
      changeActiveState={() => dispatch(changeMenuAction())}
    >
      <div className={c(styles.menu, 'menu')}>
        <div>
          <SlideInHeader
            titleText={MENU.TITLE.MENU}
            clickHandler={changeMenuAction(!menuActive)}
          />

          <div className={styles.inputfield}>
            <Search
              active={menuActive}
              placeholder={MENU.SEARCH.PLACEHOLDER}
              onSubmit={x => {
                history.push(`/zoek/${x}`);
                dispatch(changeMenuAction(!menuActive));
                ReactGA.event({
                  category: 'Other',
                  action: 'SearchAction',
                  label: x,
                });
              }} /> 
          </div>

          <MenuItem
            text={MENU.ITEM.HOME}
            path='/latest'
            onClick={() => {
              dispatch(changeMenuAction(!menuActive));
              documentSetCookie('list', 'latest');
            }}
          />
          <MenuItem
            text={MENU.ITEM.TOPPERS}
            path='/toppers'
            onClick={() => {
              dispatch(changeMenuAction(!menuActive));
              documentSetCookie('list', 'toppers');
            }}
          />
          <MenuItem
            text={`${MENU.ITEM.BRAND}TV`}
            path='/tag/dumperttv'
            onClick={() => {
              dispatch(changeMenuAction(!menuActive));
              documentSetCookie('list', 'dumperttv');
            }}
          />

          <hr className={styles.divider} />

          <div 
            className={c(styles.navitem, 'item-navigator')} 
            onClick={() => dispatch(changeHistoryMenuAction(!subHistoryActive))}>
            <span>{MENU.DATE_NAVIGATOR.BUTTON_TEXT}</span>
            <FontAwesomeIcon icon="long-arrow-alt-right" size="1x"/>
          </div>

          <hr className={styles.divider} />

          <div 
            className={c(styles.navitem, 'item-settings')} 
            onClick={() => dispatch(changeSubSettingsMenuAction(!subSettingsActive))}>
            <FontAwesomeIcon icon="cog" size="1x" />
            <span>{MENU.TITLE.SETTINGS}</span>
            <FontAwesomeIcon icon="long-arrow-alt-right" size="1x" />
          </div>

          <hr className={styles.divider} />

          <div 
            className={c(styles.navitem, 'item-dump')} 
            onClick={() => dispatch(changeSubUploadMenuAction(!subUploadFormActive))}>
            <span>{MENU.ITEM.DUMP}</span>
            <FontAwesomeIcon icon="long-arrow-alt-right" size="1x" />
          </div>

          <div className={c(styles.navitem, 'item-contact')}
            onClick={() => dispatch(changeContactFormAction(!subContactFormActive))}>
            <span>{MENU.ITEM.CONTACT}</span>
          </div>

          <MenuItem
            text={MENU.ITEM.PRIVACY}
            path='https://www.mediahuis.nl/privacy'
            external
          />
          {didomiReady && 
            <div className={styles.navitem} onClick={() => window.Didomi.preferences.show()}>
              <span>{MENU.ITEM.COOKIESETTINGS}</span>
            </div>
          }
          <MenuItem
            text={MENU.ITEM.HOUSERULES}
            path='/huisregels'
            onClick={() => dispatch(changeMenuAction(!menuActive))}
          />
          <MenuItem
            text={MENU.ITEM.FAQS}
            path='/veelgestelde-vragen'
            onClick={() => dispatch(changeMenuAction(!menuActive))}
          />          
          <MenuItem
            text={MENU.ITEM.ADVERT}
            path='https://dumpert.nl/adverteren'
            external
          />      

          <SocialBar />
        </div>
      </div>
    </SlideIn>
  );
};
